import { d as debounce, c as scrollTo, r as reanimateImages, u as updateColumnCount, m as mediaQueries, k as scrollLockViewport, e as escListener } from "./utilities-utils.js";
import { O as Overlay } from "./utilities-overlay.js";
import "./component-price-range.js";
import { r as reinitializeSwipers } from "./utilities-swiper-element.js";
import { e as enableLazyVideos } from "./base.js";
import "./utilities-nav-utils.js";
import "./vendors.js";
import "./swiper-modules.js";
import "./section-main-cart.js";
import "./component-drawer.js";
import "./utilities-toggletip-engine.js";
import "./floating-ui.js";
import "./component-quantity.js";
import "./utilities-sticky-engine.js";
import "./utilities-truncatable.js";
const overlay = new Overlay();
const hideBanners = () => {
  const cardsNumber = document.querySelectorAll("#grid-product .card").length;
  if (cardsNumber < 6)
    document.querySelectorAll(".banner--large").forEach((el) => el.style.display = "none");
  if (cardsNumber < 13)
    document.querySelectorAll(".banner--small").forEach((el) => el.style.display = "none");
};
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
    this.handleMobileSort = this.handleMobileSort.bind(this);
    this.handleSortForm = this.handleSortForm.bind(this);
    this.handleFilterForm = this.handleFilterForm.bind(this);
    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    this.querySelector("form").addEventListener("input", this.debouncedOnSubmit.bind(this));
    this.setupMobileSort();
  }
  setupMobileSort() {
    const mobileSortSelect = document.querySelector("#SortByMobile");
    if (mobileSortSelect) {
      mobileSortSelect.removeEventListener("change", this.handleMobileSort);
      mobileSortSelect.addEventListener("change", this.handleMobileSort);
    }
  }
  handleMobileSort(event) {
    const form = document.querySelector("#FacetSortForm");
    if (form) {
      const select = form.querySelector("select");
      if (select) {
        select.value = event.target.value;
        this.debouncedOnSubmit(event);
      }
    }
  }
  handleSortForm(form) {
    const filterForm = document.querySelector("#FacetFiltersForm");
    let filterParams = "";
    if (filterForm) {
      const filterFormData = new FormData(filterForm);
      filterParams = new URLSearchParams(filterFormData).toString();
    }
    const sortParams = this.createSearchParams(form);
    return filterParams ? `${filterParams}&${sortParams}` : sortParams;
  }
  handleFilterForm() {
    const forms = [];
    const sortFilterForms = document.querySelectorAll("form.facet-form");
    const sortFormsIDs = [
      "FacetAvailabilityForm",
      "FacetSortForm",
      "FacetFiltersForm",
      "FacetSearchForm"
    ];
    sortFilterForms.forEach((form) => {
      if (sortFormsIDs.includes(form.id)) {
        const searchParams = this.createSearchParams(form);
        if (searchParams !== "") {
          forms.push(searchParams);
        }
      }
    });
    const formsParams = forms.join("&").split("&");
    return [...new Set(formsParams)].join("&");
  }
  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest("form");
    if (!form) return;
    if (form.id === "FacetSortForm") {
      const searchParams2 = this.handleSortForm(form);
      this.onSubmitForm(searchParams2, event);
      return;
    }
    const searchParams = this.handleFilterForm();
    this.onSubmitForm(searchParams, event);
  }
  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    const formSelectors = "#FacetFiltersForm .js-filter, #FacetAvailabilityForm .js-filter, #FacetSortForm .js-filter";
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(formSelectors);
    const facetDetailsElementsFromDom = document.querySelectorAll(formSelectors);
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });
    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest(".js-filter") : void 0;
      return jsFilter ? element.id === jsFilter.id : false;
    };
    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter(
      (element) => !matchesId(element)
    );
    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }
        if (elementToRender.parentElement) {
          const parentJsFilter = document.querySelector(`#${elementToRender.parentElement.id} .js-filter`);
          if (parentJsFilter) {
            parentJsFilter.before(elementToRender);
          } else {
            elementToRender.parentElement.appendChild(elementToRender);
          }
        }
      }
    });
    const facetFiltersForm = document.querySelector("facet-filters-form");
    if (facetFiltersForm) {
      facetFiltersForm.setupMobileSort();
    }
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);
    if (countsToRender) {
      const closestJSFilterID = event.target.closest(".js-filter").id;
      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest(".js-filter"));
      }
    }
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }
  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener("popstate", onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    document.getElementById("grid-product").classList.add("loading");
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) : FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
    fetch(url).then((response) => response.text()).then((responseText) => {
      const html = responseText;
      FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      document.getElementById("grid-product").classList.remove("loading");
      const stickyEnginePadding = 24;
      scrollTo(
        document.querySelector("div.grid-archive__outer-container"),
        document.getElementById("grid-archive-header").offsetHeight + stickyEnginePadding
      );
    });
  }
  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    document.getElementById("grid-product").classList.remove("loading");
  }
  static renderProductGridContainer(html) {
    document.getElementById("grid-product").innerHTML = new DOMParser().parseFromString(html, "text/html").getElementById("grid-product").innerHTML;
    const grid = document.getElementById("grid-product");
    reanimateImages(grid);
    hideBanners();
    document.getElementById("grid-product").querySelectorAll(".icon").forEach((icon) => {
      icon.classList.add("loaded");
    });
    updateColumnCount();
    enableLazyVideos();
    reinitializeSwipers();
  }
  // update active facets, clear all button and icons
  static renderAdditionalElements(html) {
    const activeFacetsSelector = ".facets__active";
    const clearAllButtonSelector = ".facets__clear";
    this.updateElementFromHTML(activeFacetsSelector, html);
    this.updateElementFromHTML(clearAllButtonSelector, html);
    document.querySelectorAll("facet-filters-form .icon").forEach((icon) => {
      icon.classList.add("loaded");
    });
  }
  static updateElementFromHTML(selector, html) {
    const dynamicElement = html.querySelector(selector);
    if (!dynamicElement) return;
    document.querySelector(selector).innerHTML = dynamicElement.innerHTML;
  }
  static renderCounts(source, target) {
    const targetSummary = target.querySelector("summary");
    const sourceSummary = source.querySelector("summary");
    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }
  }
  static updateURLHash(searchParams) {
    history.pushState(
      { searchParams },
      "",
      `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
    );
  }
  static getSections() {
    return [
      {
        section: document.getElementById("grid-product").dataset.id
      }
    ];
  }
  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }
  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }
  onActiveFilterClick(event) {
    event.preventDefault();
    const searchQuery = new URL(event.currentTarget.href).search;
    const searchParams = searchQuery.substring(1);
    FacetFiltersForm.renderPage(searchParams);
  }
}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
FacetFiltersForm.setListeners();
if (!customElements.get("facet-filters-form")) {
  customElements.define("facet-filters-form", FacetFiltersForm);
}
class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector("a").addEventListener("click", (event) => {
      event.preventDefault();
      const form = this.closest("facet-filters-form#facets") || document.querySelector("facet-filters-form#facets");
      form.onActiveFilterClick(event);
      const drawer = document.querySelector('drawer-component[data-drawer="filters"]');
      if (drawer) {
        drawer.close();
      }
    });
  }
}
if (!customElements.get("facet-remove")) {
  customElements.define("facet-remove", FacetRemove);
}
class Filters extends HTMLElement {
  connectedCallback() {
    hideBanners();
    this.toggleSidebar();
    updateColumnCount();
  }
  // manage sidebar visibility logic (laptop down/desktop)
  toggleSidebar = () => {
    document.querySelectorAll(".grid-archive").forEach((archiveGrid) => {
      const toggleFiltersButton = archiveGrid.closest(".shopify-section").querySelector(".toggle-filtering");
      const filtersContainer = archiveGrid.querySelector(".grid-archive__filters-container");
      const isMobileFiltersOpen = () => archiveGrid.classList.contains("grid-archive__main-container-mobile--filters-shown");
      const closeFilters = () => {
        archiveGrid.classList.remove("grid-archive__main-container--filters-shown");
        escListener(false, closeFilters);
      };
      const openFilters = () => {
        archiveGrid.classList.add("grid-archive__main-container--filters-shown");
        escListener(true, closeFilters);
      };
      const toggleFilters = () => {
        const isFiltersOpen = archiveGrid.classList.contains(
          "grid-archive__main-container--filters-shown"
        );
        if (isFiltersOpen) {
          closeFilters();
        } else {
          openFilters();
        }
      };
      const closeFiltersMobile = () => {
        archiveGrid.classList.remove("grid-archive__main-container-mobile--filters-shown");
        scrollLockViewport(false, "laptop-down");
        overlay.close();
        escListener(false, closeFiltersMobile);
      };
      const outsidePopupClickListener = () => {
        filtersContainer.addEventListener("click", outsidePopupClick);
      };
      const outsidePopupClick = (e) => {
        if (!e.target.closest(".facets")) {
          closeFiltersMobile();
          filtersContainer.removeEventListener("click", outsidePopupClick);
        }
      };
      const openFiltersMobile = () => {
        archiveGrid.classList.add("grid-archive__main-container-mobile--filters-shown");
        scrollLockViewport(true, "laptop-down");
        overlay.open({
          attachElements: [filtersContainer]
        });
        escListener(true, closeFiltersMobile);
        outsidePopupClickListener();
      };
      if (toggleFiltersButton) {
        toggleFiltersButton.addEventListener("click", () => {
          if (mediaQueries.isLargeDown.matches) {
            openFiltersMobile();
          } else {
            toggleFilters();
          }
        });
      }
      if (filtersContainer) {
        filtersContainer.querySelector(".facets__mobile-close").addEventListener("click", (e) => {
          e.preventDefault();
          closeFiltersMobile();
        });
      }
      const resetOnResize = () => {
        mediaQueries.isLargeDown.addEventListener("change", () => {
          if (mediaQueries.isLargeDown.matches) {
            if (isMobileFiltersOpen()) {
              closeFiltersMobile();
            }
          }
        });
      };
      resetOnResize();
    });
  };
  syncSorts = () => {
    if (document.querySelectorAll("#SortByMobile").length == 0) return;
    const sortByDropdowns = document.querySelectorAll("#SortBy, #SortByMobile");
    sortByDropdowns.forEach((sortByDropdown) => {
      sortByDropdown.addEventListener("change", function(e) {
        sortByDropdowns.forEach((select) => {
          select.value = e.target.value;
        });
        const inputEvent = new Event("input");
        document.querySelector("#FacetSortForm").dispatchEvent(inputEvent);
      });
    });
  };
}
if (!customElements.get("filters-component")) {
  customElements.define("filters-component", Filters);
}
